import { getParagraph, getExplain, getParagraphChild } from '../createRender';

let reverseParseTextView = data => {
    let obj = createRender(data);

    return obj;
}

function createRender(data) {
    if (!data.stem) {
        return {}
    }

    // 题干
    let stem = getParagraph(data.stem);
    // 分类类型 Map
    let stemMap = {};
    stem.forEach(item => {
        if (item.style === "math_category") {
            item.children.forEach(val => {
                if (val.type === 'drag') {
                    val.drag.forEach(v => {
                        stemMap[v.id] = v.content;
                    });
                }
            });
        }
    });
    // 答案 Array
    let answer = data.answer ? getAnswerArr(data.answer) : null;
    // 答案 Map
    let answerMap = data.answer ? getAnswerMap(data.answer) : null;
    // 选项
    let item_list = data.item_list ? data.item_list : null;
    data.item_list.map(item => {
        item.item = getParagraphChild([], item.item);
        return item;
    });
    // 选项 Map
    let itemMap = {};
    item_list.forEach(item => {
        itemMap[item.code] = item.item;
    });
    // 解析
    let explain = data.explain ? getExplain(data.explain) : null;

    const render = { stem, stemMap, answer, answerMap, item_list, itemMap, explain };
    return render;
}

/**
 * 获取答案
 * @param {String} answer
 * @returns {Array}
 */
const getAnswerArr = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    return answer;
};

/**
 * 获取答案
 * @param {String} answer
 * @returns {Object}
 */
const getAnswerMap = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    const answerMap = {};
    answer.forEach(item => {
        answerMap[item.drop_id] = item.result.split('|');
    });
    return answerMap;
};

export { reverseParseTextView };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/classify/createRender.js